import { SampleBoardMaterialRecipeItem } from "@app/strain/sample-boards/models/sample-board-material-recipe-item.model";
import { MaterialRequestStatus } from "@app/strain/material-requests/models/material-request-status.enum";

export class SampleBoardMaterialRequest {
    id: number;
    name: string;
    date: string;
    icon?: string;
    status: MaterialRequestStatus;
    materialItems?: SampleBoardMaterialRecipeItem[];

    constructor(entry: any = {}) {
        this.id = entry?.id;
        this.name = entry?.name || '';
        this.date = entry?.date;
        this.icon = entry?.icon;
        this.status = entry.status as MaterialRequestStatus;
        this.materialItems = entry.materials ? entry.materials.map(ntry => new SampleBoardMaterialRecipeItem(ntry)) : [];
    }


}
